import * as React from 'react';

import { DimeFilterCountBadge } from './DimeFilterCountBadge.js';
import { cn } from './lib/utils.js';

export type DimeFilterButtonContentProps = Readonly<{
  label?: string;
  /** Omit for text-only buttons. */
  icon?: React.ReactNode;
  count?: number;
  /** Defaults to true when an icon is shown. Pass false to keep the label at every breakpoint. */
  hideLabelBelowSm?: boolean;
}>;

/** Icon, label, and count badge shared by Filter buttons and combobox filter triggers. */
export function DimeFilterButtonContent({
  label = 'Filter',
  icon = null,
  count = 0,
  hideLabelBelowSm,
}: DimeFilterButtonContentProps) {
  const hideLabel = hideLabelBelowSm ?? icon != null;
  return (
    <>
      {icon}
      <span className={cn(hideLabel && 'hidden sm:inline')}>{label}</span>
      <DimeFilterCountBadge count={count} />
    </>
  );
}
